import { ymdLocal } from '../lib/format.js';

export function DateStepper({ dateYmd, isToday, onChange }) {
  // Server allows last 31 days through next 28 days (last week for payroll,
  // this week for ops, next two weeks for planning + a buffer). Match it.
  const todayYmd = ymdLocal(new Date());
  function offsetYmd(daysFromToday) {
    const d = new Date(todayYmd + 'T12:00:00Z');
    d.setUTCDate(d.getUTCDate() + daysFromToday);
    return ymdLocal(d);
  }
  const minYmd = offsetYmd(-31);
  const maxYmd = offsetYmd(28);
  const friendly = new Date(dateYmd + 'T12:00:00')
    .toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' });
  function shift(days) {
    const d = new Date(dateYmd + 'T12:00:00');
    d.setUTCDate(d.getUTCDate() + days);
    const next = ymdLocal(d);
    if (next < minYmd || next > maxYmd) return;
    onChange(next);
  }
  const atStart = dateYmd <= minYmd;
  const atEnd   = dateYmd >= maxYmd;
  const isFuture = dateYmd > todayYmd;
  const tag = isToday ? 'Today' : isFuture ? `Planning (+${Math.round((new Date(dateYmd+'T12:00:00Z') - new Date(todayYmd+'T12:00:00Z'))/86400000)}d)` : null;
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
      <button className="btn-secondary" style={{ padding: '6px 10px', opacity: atStart ? 0.4 : 1 }}
              disabled={atStart} onClick={() => shift(-1)} title="Previous day">←</button>
      <input type="date" value={dateYmd} min={minYmd} max={maxYmd}
             onChange={(e) => e.target.value && onChange(e.target.value)}
             style={{ padding: '6px 8px', border: '1px solid #ddd', borderRadius: 6, fontSize: 13, fontFamily: 'inherit' }} />
      <button className="btn-secondary" style={{ padding: '6px 10px', opacity: atEnd ? 0.4 : 1 }}
              disabled={atEnd} onClick={() => shift(1)} title="Next day">→</button>
      <button className="btn-secondary" style={{ padding: '6px 12px', fontSize: 12, opacity: isToday ? 0.5 : 1 }}
              disabled={isToday} onClick={() => onChange(todayYmd)}>
        Today
      </button>
      <span style={{ marginLeft: 8, fontSize: 12, color: '#37474f', fontWeight: 600 }}>{friendly}</span>
      {tag && (
        <span style={{ fontSize: 10, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.6px',
                       padding: '2px 8px', borderRadius: 10,
                       background: isFuture ? '#e3f2fd' : '#e8f5e9',
                       color: isFuture ? '#1565c0' : '#2e7d32' }}>
          {tag}
        </span>
      )}
    </div>
  );
}
